import { useTranslation } from 'react-i18next'

import Widget from '../Widget'
import EditWidgetForm from './EditWidgetForm'

export const useEMBED_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'EMBED',
    name: t('widgets.embed.name'),
    description: t('widgets.embed.description'),
    color: 'darkGreen',
    icon: 'RiTimerLine',
    categories: [t('widgets.embed.category')],
    previewWidth: '100%',

    initialState: {
      name: t('widgets.embed.initialStateName'),
      size: { width: 100, height: 750 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
